// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components----Drawer-module---wrapper---23V6i","imgWrapper":"src-components----Drawer-module---imgWrapper---6ehmW","modal":"src-components----Drawer-module---modal---1nbcb","contact":"src-components----Drawer-module---contact---2TTtP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Drawer.module.css
// module id = 724
// module chunks = 226573449209678